import { FormControlLabel, FormHelperText, MenuItem } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React, { useCallback } from 'react';
import { useRecoilValueLoadable } from 'recoil';
import { LabelledOutline } from '../../../common/final-form-material-ui/LabelledOutline';
import { FormikSwitch } from '../../../common/formik-material-ui/FormikSwitch';
import { IUserAtom, user } from '../../../recoil/atoms/user';
import {
  DefaultAction,
  getDefaultActionUrl,
  IActionType,
} from '../dropdowns/DefaultAction';
import InfoPanel from '../InfoPanel/InfoPanel';
import { RecordNow } from '../recorder/RecordNow';

const useStyles = makeStyles(() => ({
  root: {
    '& .MuiFormHelperText-root': {
      paddingLeft: '16px',
      fontSize: '12px',
    },
  },
}));
export default function DestinationTabActions({
  formik,
  setFilenames,
  filenames,
  setUploadedFiles,
  setFilepaths,
  filepaths,
  uploadedFiles,
}) {
  const userLoadable = useRecoilValueLoadable(user);
  const userContents = userLoadable.contents as IUserAtom;
  const [ownerDestination, setOwnerDestination] = React.useState(false);
  const [dealOwnerDestination, setDealOwnerDestination] = React.useState(false);

  const classes = useStyles();

  const onChangeFile = (type) => ({ target: { files } }) => {
    setFilenames({
      ...filenames,
      [type]:
        files.length > 1 ? `${files.length} files` : files?.[0]?.name ?? '',
    });
    setFilepaths({
      ...filepaths,
      [type]: files?.[0] && URL.createObjectURL(files?.[0]), // create file blob
    });
    setUploadedFiles({
      ...uploadedFiles,
      [type]: files,
    }); // take first file
  };
  const handleRecording = useCallback(
    (type: string) => (files: any) => {
      setUploadedFiles({
        ...uploadedFiles,
        [type]: files,
      });
    },
    [uploadedFiles]
  );
  React.useEffect(() => {
    formik?.values?.ruleActions?.forEach((rule) => {
      if (rule?.type === 'Has Owner' && rule?.value === 'true') {
        setOwnerDestination(true);
      }
      if (rule?.type === 'Deal Has Owner' && rule?.value === 'true') {
        setDealOwnerDestination(true);
      }
    });
  }, [formik]);

  return (
    <div className={clsx('container', classes.root)}>
      <InfoPanel>
        <div>
          Set a destination for your number(s) on this tab. Number(s) selected
          in this first tab for which the Condition(s) selected in the second
          tab apply will route to the Destination set here. Select a Destination
          from the dropdown below.
        </div>
      </InfoPanel>
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <LabelledOutline label={`Destination`}>
          <DefaultAction
            defaultAction={getDefaultActionUrl({
              type: formik.values.defaultActionPayload?.type as IActionType,
              parentType: 'routing',
              businessid: userContents.businessid,
              user: formik.values.defaultActionPayload?.user,
              group: formik.values.defaultActionPayload?.group,
              ivr: formik.values.defaultActionPayload?.ivr,
              queue: formik.values.defaultActionPayload?.queue,
              voicemail: '',
            })}
            actionType={formik.values.defaultActionPayload?.type}
            label="Destination"
            formik={formik}
            typeName="defaultActionPayload.type"
            ivrName="defaultActionPayload.ivr"
            groupName="defaultActionPayload.group"
            userName="defaultActionPayload.user"
            queueName="defaultActionPayload.queue"
            showOwner={ownerDestination}
            showDealOwner={dealOwnerDestination}
          />
        </LabelledOutline>
        {(formik?.values?.defaultActionPayload?.type === 'owner' ||
          formik?.values?.defaultActionPayload?.type === 'dealOwner') && (
          <LabelledOutline label={`Play Message`}>
            <FormControlLabel
              control={
                <FormikSwitch
                  name="destinationMessage.showMessage"
                  formik={formik}
                  color="primary"
                  type="checkbox"
                />
              }
              labelPlacement="start"
              label="Play Message Before Routing"
              id="playMessage"
            />
            <FormHelperText>
              Before a call is transferred to the{' '}
              {formik?.values?.defaultActionPayload?.type === 'owner'
                ? 'contact owner'
                : 'deal owner'}
              , a message will play letting the caller know they’re being routed
            </FormHelperText>
          </LabelledOutline>
        )}
        {formik.values.destinationMessage.showMessage &&
          (formik?.values?.defaultActionPayload?.type === 'owner' ||
            formik?.values?.defaultActionPayload?.type === 'dealOwner') && (
            <RecordNow
              dropdownLabel="Message Type"
              dropdownName="destinationMessage.messageType"
              dropdownType={formik.values.destinationMessage.messageType}
              outlineLabel="Message"
              ttsName="destinationMessage.message"
              filenameName="destinationMessage.file"
              filesizeName="destinationMessage.name"
              formik={formik}
              filepath={filepaths.greeting}
              filename={filenames.greeting}
              onChangeFile={onChangeFile('greeting')}
              onRecording={handleRecording('greeting')}
            >
              <MenuItem value="tts">Text-to-Speech</MenuItem>
              <MenuItem value="mp3">MP3</MenuItem>
              <MenuItem value="record">Record Now</MenuItem>
            </RecordNow>
          )}
      </div>
    </div>
  );
}
